export interface ICheckPasswordResetCodeResponse {
  valid: boolean;
}

export class CheckPasswordResetCodeResponse
  implements ICheckPasswordResetCodeResponse {
  valid: boolean;
}
